// @flow
import { getLoginComplete, getShowLoginAnimation } from '~/core/state/application/selectors';
import { startLoginAnimation, stopLoginAnimation } from '~/core/state/application/actions';

import { connect } from 'react-redux';
import { getTranslationsLoading } from '~/core/state/translations/selectors';
import LoginIndicator from './component';

const mapStateToProps = state => ({
    isLoading: getTranslationsLoading(state),
    isLoggedIn: getLoginComplete(state),
    showLoginAnimation: getShowLoginAnimation(state)
});

const mapDispatchToProps = { startLoginAnimation, stopLoginAnimation };

export default connect(mapStateToProps, mapDispatchToProps)(LoginIndicator);



// WEBPACK FOOTER //
// ./src/components/widgets/indicators/login/index.js